"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("modal", {
    attrs: {
      show: true,
      "show-close": true
    },
    on: {
      close: _vm.close
    }
  }, [_c("h1", {
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_vm._v("Adicionar novo documento")]), _vm._v(" "), _c("form", {
    attrs: {
      id: "formNewTypeService"
    }
  }, [_c("app-input", {
    attrs: {
      label: "Nome da documento",
      placeholder: "Informe o nome do documento",
      error: _vm.$v.form.Name.$error
    },
    on: {
      "update:error": function updateError($event) {
        return _vm.$set(_vm.$v.form.Name, "$error", $event);
      }
    },
    model: {
      value: _vm.$v.form.Name.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.Name, "$model", $$v);
      },
      expression: "$v.form.Name.$model"
    }
  }), _vm._v(" "), _c("app-select", {
    attrs: {
      error: _vm.$v.form.Organization.$error,
      label: "Cliente",
      placeholder: "Selecione o provedor do serviço",
      items: _vm.listAllClients,
      option: "OrganizationId",
      "name-item": "Name"
    },
    on: {
      "update:error": function updateError($event) {
        return _vm.$set(_vm.$v.form.Organization, "$error", $event);
      }
    },
    model: {
      value: _vm.clientUser,
      callback: function callback($$v) {
        _vm.clientUser = $$v;
      },
      expression: "clientUser"
    }
  }), _vm._v(" "), _vm.listBusinessUnits.length ? _c("app-select", {
    attrs: {
      error: _vm.$v.form.BusinessUnitId.$error,
      label: "Área de negócio",
      placeholder: "Área de negócio",
      items: _vm.listBusinessUnits,
      option: "BusinessUnitId",
      "name-item": "Name"
    },
    on: {
      "update:error": function updateError($event) {
        return _vm.$set(_vm.$v.form.BusinessUnitId, "$error", $event);
      }
    },
    model: {
      value: _vm.$v.form.BusinessUnitId.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.BusinessUnitId, "$model", $$v);
      },
      expression: "$v.form.BusinessUnitId.$model"
    }
  }) : _vm._e(), _vm._v(" "), _c("b-field", {
    class: _vm.$v.form.Logo.$error ? "is-danger" : "",
    attrs: {
      label: "Arquivo"
    }
  }, [_c("b-upload", {
    attrs: {
      "drag-drop": "",
      accept: _vm.typeFile
    },
    model: {
      value: _vm.fileLogo,
      callback: function callback($$v) {
        _vm.fileLogo = $$v;
      },
      expression: "fileLogo"
    }
  }, [_c("section", {
    staticClass: "section"
  }, [_c("div", {
    staticClass: "content has-text-centered"
  }, [_c("b-icon", {
    attrs: {
      icon: "file-document",
      size: "is-large"
    }
  }), _vm._v(" "), !_vm.fileLogo ? _c("p", [_vm._v("Busque ou arraste o arquivo")]) : _c("p", [_vm._v(_vm._s(_vm.fileLogo.name || "Arquivo selecionado"))])], 1)])])], 1)], 1), _vm._v(" "), _c("b-button", {
    attrs: {
      slot: "footer",
      type: "is-info",
      loading: _vm.isLoading
    },
    on: {
      click: _vm.checkForm
    },
    slot: "footer"
  }, [_vm._v("\n    Salvar\n  ")])], 1);
};
exports.render = render;
var staticRenderFns = [];
exports.staticRenderFns = staticRenderFns;
render._withStripped = true;